import { SERVICE_MEN } from "../shared/tagTypes";
import { baseApi } from "./base";

const serviceManApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [SERVICE_MEN],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getServiceMen: builder.query({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-men`
                }),
                providesTags: [SERVICE_MEN],
            }),
            getServiceMan: builder.query({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-men/${payload.userId}`
                }),
                providesTags: [SERVICE_MEN],
            }),
            createServiceMan: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-men`,
                    method: "POST",
                    body: payload.body,
                }),
                invalidatesTags: [SERVICE_MEN],
            }),
            updateServiceMan: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-men/${payload.userId}`,
                    method: "PUT",
                    body: payload.body,
                }),
                invalidatesTags: [SERVICE_MEN],
            }),
            deleteServiceMan: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-men/${payload.userId}`,
                    method: "DELETE",
                }),
                invalidatesTags: [SERVICE_MEN],
            })
        }),

        overrideExisting: false,
    });

export const {
    useGetServiceMenQuery,
    useLazyGetServiceMenQuery,
    useGetServiceManQuery,
    useLazyGetServiceManQuery,
    useCreateServiceManMutation,
    useUpdateServiceManMutation,
    useDeleteServiceManMutation
} = serviceManApi;
